






























import { vxm } from '../store.vuex';
import { Component, Vue } from 'vue-property-decorator';
import VueToastr from '@deveodk/vue-toastr';
import '@deveodk/vue-toastr/dist/@deveodk/vue-toastr.css';

Vue.use(VueToastr, {
  defaultPosition: 'toast-top-right',
  defaultType: 'info',
  defaultTimeout: 7000,
});

@Component({
  name: 'JobAlertValidation',
  components: {},
})
export default class JobAlertValidation extends Vue {
  $wlToastr: any;
  private errorString: string = '';
  private successString: string = '';
  private errorFlag: boolean = false;
  private displayMessage: string = '';

  //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

  public validateJobAlert(hash) {
    if (vxm.configs.getGlobalConfigValue('ENABLE_JOBALERT_V2')) {
      this.validateNewJobAlert(hash);
    } else {
      this.validateOldJobAlert(hash);
    }
  }

  validateNewJobAlert(hash) {
    vxm.jobs.validateJobAlertByHash(hash).then((res) => {
      if (res.isValidatedJobAlert === true) {
        vxm.users.setEmail(res.email);
        this.$wlToastr(
          'success',
          this.$t(this.successString),
          'Your job alert has been successfully activated! You will now receive job alert updates with your search criteria.',
        );
        this.displayMessage =
          'Your job alert has been successfully activated! You will now receive job alert updates with your search criteria.';
        return true;
      } else {
        this.$wlToastr(
          'error',
          this.$t(this.errorString),
          'Error! Could not validate job alert!',
        );
        this.errorFlag = true;
        this.displayMessage = 'Error! Could not validate job alert!';
        console.log(this.errorString);
        return false;
      }
    });
  }

  validateOldJobAlert(hash) {
    vxm.jobs.validateJobAlertEmail(hash).then((res) => {
      if (res === true) {
        this.$wlToastr(
          'success',
          this.$t(this.successString),
          'Your job alert has been successfully activated! You will now receive job alert updates with your search criteria.',
        );
        this.displayMessage =
          'Your job alert has been successfully activated! You will now receive job alert updates with your search criteria.';
        return true;
      } else {
        this.$wlToastr(
          'error',
          this.$t(this.errorString),
          'Error! Could not validate job alert!',
        );
        this.errorFlag = true;
        this.displayMessage = 'Error! Could not validate job alert!';
        console.log(this.errorString);
        return false;
      }
    });
  }

  //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
  mounted() {
    const hashCode = this.$route.params.hashCode;
    this.validateJobAlert(hashCode);
  }

  redirectToSignUp() {
    if (vxm.configs.getGlobalConfigValue('USE_LOGIN_SIGNUP_V2')) {
      this.$router.push({ path: '/signup' })
    }
    else {
      this.$router.push({
        name: 'Signup'
      });
    }

  }

  get isJobAlertEnhancementEnabled(): boolean {
    return vxm.configs.getGlobalConfigValue('ENABLE_JOBALERT_V2');
  }

  get isInternalTpEnable(): boolean {
    return vxm.configs.getGlobalConfigValue('ENABLE_INTERNAL_TP_ONLY');
  }

  get isLoggedIn() {
    return vxm.users.isLoggedIn;
  }
}
